module.exports = __webpack_public_path__ + "static/img/empty@2x.df377554.png";